<!--
 * @Author: lishun
 * @Date: 2021-03-05 15:52:18
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2022-03-24 13:35:41
 * @Description: 描述
 * @Copyright: Cloud-Star. Co. Ltd. All rights reserved.
-->
<template>
    <div class="layout-rctable-container recharge-result-container">
        <Helpinfo :helpData="helpData" />
        <div class="hint-tip">
            <div class="hint">
                <i class="icon-prompt-1-o"></i>
                <div class="hintFont">
                    <p>{{$t('如果您已支付完成，请关闭当前页面，充值将稍后到账。')}}</p>
                </div>
            </div>
        </div>
        <div v-if="!isSuccess"
             class="result-wrap">
            <div class="result-item">
                <span class="result-label">{{$t('商品订单')}}：</span>
                <span class="orderId">{{mchOrderId || '2032941234123412341'}}</span>
            </div>
            <div class="result-item">
                <span class="result-label">{{$t('支付金额')}}：</span>
                <span class="amount">{{$money(amount ||10,2)}}</span>
            </div>
            <div class="result-item">
                <span class="result-label">{{$t('支付方式')}}：</span>
                <p class="pay-way-wrap wx-pay active"></p>
            </div>
            <div class="result-code">
                <div class="code">
                    <div class="qr-code">
                        <p id="qrCode"></p>
                    </div>
                    <span>{{$t('请打开手机微信，扫一扫完成支付')}}</span>
                </div>
                <p class="arrow"></p>
                <p class="img"></p>
            </div>
        </div>
        <div v-else
             class="result-wrap success-wrap">
            <p class="pay-way-wrap wx-pay"
               style="margin-left: -15px; border: none"></p>
            <div class="info">
                <span class="icon-wrap">
                    <Icon type="ios-checkmark"
                          size="30"
                          color="#00c700" />
                </span>
                <span>{{$t('交易付款成功，正在跳转至商户页面。')}}</span>
            </div>
        </div>
    </div>
</template>
<script>
import QRCode from 'qrcodejs2'
import Helpinfo from '@/views/components/basic/helpinfo'
export default {
    name: 'rechargeResult',
    components: {
        Helpinfo
    },
    data () {
        return {
            helpData: {
                type: '',
                modelName: this.$t('微信充值')
            },
            amount: '',
            mchOrderId: '',
            qrCode: '',
            userSid: this.$store.state.user.currentUser.info.userSid || '',
            rechargeWS: null,
            isSuccess: false
        }
    },
    created () {
        this.initRechargeDetail()
    },
    methods: {
        initRechargeDetail () {
            const detail = JSON.parse(localStorage.getItem('uerRechargeData'))
            this.amount = detail.amount
            this.mchOrderId = detail.mchOrderId
            this.$nextTick(() => {
                this.initCode(detail.codeUrl)
                this.websoctRefesh()
            })
        },
        initCode (code) {
            this.qrCode = new QRCode('qrCode', {
                width: 200,
                height: 200,
                text: code,
                colorDark: '#000',
                colorLight: '#fff'
            })
        },
        websoctRefesh () {
            this.rechargeWS = this.$websocket(`/topic/users/${this.userSid}/recharge`, (result) => {
                if (result.body === 'RechargeSuccess') {
                    this.$Message.success({
                        content: '充值成功'
                    })
                    this.isSuccess = true
                    this.timer = setTimeout(() => {
                        this.$router.push({
                            path: '/mgt/deals'
                        })
                    }, 3000)
                }
            })
            // 存储websocket
            this.$store.commit('addWsList', {
                url: `/topic/users/${this.userSid}/recharge`,
                callback: () => { }
            })
        }
    },
    destroyed () {
        localStorage.removeItem('uerRechargeData')
        this.timer = null
    }
}
</script>
<style lang="less" scoped>
.recharge-result-container {
    .hint-tip {
        margin: 15px 15px 0 15px;
        .hintFont {
            p {
                span {
                    color: #ff8400;
                    font-weight: 500;
                }
            }
        }
    }

    .result-wrap {
        padding: 50px;
        margin: 0 auto;
        height: 100%;
        .result-item {
            line-height: 50px;
            font-size: 14px;
            .amount {
                color: #ff8400;
                font-size: 20px;
            }
        }
        .result-code {
            display: flex;
            justify-content: center;
            align-items: center;
            margin-top: 30px;
            padding: 30px;
            background: #f5f6f7;
            .code {
                display: flex;
                flex-direction: column;
                justify-content: center;
                height: 325px;
                .qr-code {
                    padding: 10px;
                    width: 220px;
                    height: 220px;
                    background: #fff;
                }
                span {
                    display: block;
                    line-height: 25px;
                    text-align: center;
                    color: #fff;
                    background-color: #00c700;
                }
            }
            .arrow {
                width: 200px;
                height: 220px;
                background-image: url('../../../assets/images/pay/wx-arrow.png');
                background-position: bottom;
                background-repeat: no-repeat;
            }
            .img {
                width: 225px;
                height: 325px;
                background-image: url('../../../assets/images/pay/sao.png');
                background-size: cover;
            }
        }
    }
    .success-wrap {
        width: 50%;
        .info {
            display: flex;
            align-items: center;
            padding-left: 30px;
            margin-top: 15px;
            line-height: 50px;
            background: #00c700;
            color: #fff;
            .icon-wrap {
                margin-right: 20px;
                width: 24px;
                height: 24px;
                text-align: center;
                border-radius: 50%;
                background: #fff;
            }
        }
    }
}
</style>
